import { combineActions, handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/anewstip'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  importResult: []
})

export default handleActions({
  [combineActions(
    Actions.importStart,
    Actions.addJournalistsToDistributionList
  )]: state => state.set('importResult', fromJS([])),
  [Actions.importSuccess]: (state, { payload }) => state.update(
    'importResult', oldValue => (oldValue.merge(fromJS(payload)))
  ),
  [Actions.clearModuleData]: () => initialState,
  [AppActions.resetState]: () => initialState
}, initialState)
